import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManageVendorsPageRoutingModule } from './manage-vendors-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { ListSharedModule } from '../../../lists/shared/list-shared.module';
import { ManageVendorsPage } from './manage-vendors.page';
import { ManageVendorsEffects } from './effects/manage-vendors.effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    ListSharedModule,
    TranslateModule,
    ManageVendorsPageRoutingModule,
    ReactiveFormsModule,
    EffectsModule.forFeature([ManageVendorsEffects]),
  ],
  declarations: [ManageVendorsPage],
})
export class ManageVendorsPageModule {}
